<template>
  <div class="sign_in_box">
    <div class="box">
      <img src="/static/index/index17.png" alt="">
      <div>
        <div class="b1">
          <div class="b11" @click="type=1">密码注册</div>
          <!-- <div :class="type==2?'b11':''" @click="type=2">短信注册</div> -->
        </div>
        <div class="b2">请填写账号信息</div>
        <div class="b3"><el-input v-model="phone" type="number" placeholder="请输入手机号码"></el-input></div>
        <div class="b3" v-if="type==1"><el-input  v-model="password" type="password" placeholder="请输入密码"></el-input></div>
        <div class="b3" v-if="type==1"><el-input v-model="password2" type="password" placeholder="请确认密码"></el-input></div>
        <!-- <div class="b3" v-if="type==2"><el-input v-model="input" placeholder="请输入短信验证码"></el-input><div class="b31">获取验证码</div></div> -->
        <!-- <div class="b7">通过点击"注册" 代表您同意<span>《xxxx协议》《免责声明》</span>及<span>《隐私条款》</span></div> -->
        <div class="b4">
          <el-button type="primary" @click="submit">注册</el-button>
        </div>
        <div class="b6"></div>
        <div class="b5" v-if="!aid">已注册？<span @click="jump('/login')">点击登录</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Cookie from 'js-cookie'
export default {
  props: [],
  components: {
  },
  data() {

    return {
      checked:false,
      phone:'',
      password:'',
      password2:'',
      type:1,
      aid:''
    };
  },
  mounted(){
    if(Cookie.get('id')){
      this.aid=Cookie.get('id')
    }else{
      this.aid=''
    }
  },
  methods: {
    ...mapActions([]),
    jump(e){
      this.$router.push(e)
    },
    submit(){
      if(!this.phone){
        this.$message.error("请输入手机号码");
        return;
      }else if(!this.password){
        this.$message.error("请输入密码");
        return;
      }else if(!this.password2){
        this.$message.error("请输入确认密码");
        return;
      }else if(this.password2 != this.password){
        this.$message.error("两次密码不一致，请重新输入");
        return;
      }
      let obj={
        telephone:this.phone,
        password:this.password2
      }
      this.$axios
        .post("/do_register_account",this.$qs.stringify(obj))
        .then((res) => {
          console.log(res);
          if(res.data.data.aid>0){
             this.$message({
              message: "注册成功",
              type: "success",
            });
            Cookie.set('id','')
            this.phone=''
            this.password=''
            this.password2=''
            this.$router.push('/login')
          }else if(res.data.data.aid==-1){
            this.$message.error("该账号已存在");
          }
          
        });
    },
    submitForm() {
      
    }
  }
};
</script>
<style lang="scss" scoped>
.sign_in_box{
  width: 100%;
  // height: 100%;
  background: #FFFFFF;
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
  .box{
    width: 1200px;
    margin: 0 auto;
    // padding: 0 23px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &>img{
      width: 639px;
      height: 566px;
    }
    &>div{
      width: 522px;
      .b1{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 43px;
        div{
          width: 45%;
          text-align: left;
          font-size: 40px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #999999;
        }
        .b11{
          font-weight: bold;
          color: #333333;
        }
      }
      .b2{
        font-size: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 600;
        color: #333333;
        margin-bottom: 26px;
      }
      .b3{
        width: 522px;
        height: 53px;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .el-input{
          width: 95%;
          /deep/ .el-input__inner{
          background: transparent;
          border: none;
          
          &::placeholder {
            font-size: 18px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #999999;
          }
        }
        }
        .b31{
          font-size: 18px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #FF5602;
          position: absolute;
          right: 20px;
          top: 15px;
          z-index: 99;
        }
        
      }
      .b4{
        margin-top: 40px;
        .el-button{
          padding: 16px 76px;
          background: #198AFA;
          margin-right: 20px;
        }
      }
      .b5{
        font-size: 18px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999; 
        margin-bottom: 27px;
        span{
          color: #198AFA;
        }
      }
      .b6{
        width: 510px;
        height: 1px;
        background: #cccccc46;
        margin: 20px auto;
      }
      .b7{
          font-size: 14px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #999999;
        margin-top: 20px;
        span{
            color: #579EE0;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/registered/index.vue